import { jsx as _jsx } from "react/jsx-runtime";
export function Button({ variant = "primary", block = false, size = "md", pending = false, className, disabled, children, ...rest }) {
    const classes = [
        "btn",
        `btn--${variant}`,
        size !== "md" ? `btn--${size}` : "",
        block ? "btn--block" : "",
        pending ? "is-pending" : "",
        className ?? "",
    ]
        .filter(Boolean)
        .join(" ");
    return (_jsx("button", { className: classes, disabled: disabled || pending, "aria-busy": pending, ...rest, children: children }));
}
//# sourceMappingURL=Button.js.map